import aavyaTheme from "@aavya/theme/index";
import $ from "jquery";

export default function () {
    const homePage = document.querySelector('.template-index');
    if (homePage) {
        const arrow = '<svg fill="#000000" viewBox="0 0 129 129"><path d="M121.3 34.6c-1.6-1.6-4.2-1.6-5.8 0l-51 51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8 0-1.6 1.6-1.6 4.2 0 5.8l53.9 53.9c.8.8 1.8 1.2 2.9 1.2 1 0 2.1-.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2.1-5.8z"/></svg>';
        aavyaTheme.slickSlider.create($('#quote'), {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '#quoteNav',
            infinite: true,
            centerMode: true
        });
        aavyaTheme.slickSlider.create($('#quoteNav'), {
            focusOnSelect: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            asNavFor: '#quote',
            arrows: true,
            infinite: true,
            centerMode: true,
            centerPadding: '0px',
            swipeToSlide: true,
            autoplay: true,
            autoplaySpeed: 3000,
            prevArrow: arrow,
            nextArrow: arrow,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 380,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });

        const slider = () => {
            return aavyaTheme.slickSlider.create($('#mobileSlider'), {
                mobileFirst :true,
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                infinite: true,
                swipeToSlide: true,
                prevArrow: arrow,
                nextArrow: arrow,
                responsive: [
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 680,
                        settings: {
                            slidesToShow: 8,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 10,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        };

        let $slider = slider();

        $(window).resize(function(e){
            if(window.innerWidth < 1024) {
                if (!$slider.hasClass('slick-initialized')) {
                    slider();
                }
            }
        });
    }
}
